<template>
  <div class="">
    <section id="header">
      <router-link to="/">FUNTINY</router-link>
    <template v-if="routeName !== 'login'">
      
    
      
      <Search />
      <router-link to="/about">About</router-link>
    
    </template>
    
    </section>
    <section class="wrapper style1">
      <router-view />
    </section>
  </div>
</template>

<style lang="scss">
#header {
  padding: 30px;

  a {
    border-bottom: none;

    &:not(.router-link-exact-active) {
      font-weight: 700;
    }
  }
}
.capsule {
  border-width: 5px !important;
}
</style>

<script>
// @ is an alias to /src
import Search from '@/components/Search.vue';

export default {
  data() {
    return {
      routeName: null
    };
  },

  watch: {
    $route: 'currentRoute'
  },

  mounted: function() {
    this.routeName = this.$route.name;
  },

  methods: {
    currentRoute() {
      this.$nextTick(() => {
        this.routeName = this.$route.name;
      });
    }
  },
  components: {
    Search
  }
};
</script>
